<div class="flex-row-container">
    <mat-icon class="m-r10 font22" [ngClass]="styleClass">{{ icon }}</mat-icon>
    <span class="font20 flex-1">{{ msg }}</span>
    <mat-icon class="m-r10 font22 pointer" [ngClass]="styleClass" (click)="dismisss()">close</mat-icon>
</div>